/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Slider_Scan_PapersInputs */

const en_app_slider_scan_papers = /** @type {(inputs: App_Slider_Scan_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Papers.`)
};

const es_app_slider_scan_papers = /** @type {(inputs: App_Slider_Scan_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escanear artículos.`)
};

/**
* | output |
* | --- |
* | "Scan Papers." |
*
* @param {App_Slider_Scan_PapersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_slider_scan_papers = /** @type {((inputs?: App_Slider_Scan_PapersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Slider_Scan_PapersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_slider_scan_papers(inputs)
	return en_app_slider_scan_papers(inputs)
});